import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const setThemeOnScroll = () => {

	let els = document.querySelectorAll('[data-set-theme]')

	if (!els.length) return

	els.forEach(el => {
		ScrollTrigger.create({
			trigger: el,
			start: 'top 48px',
			end: 'bottom 48px',
			// markers: true,
			onEnter: () => {
				if (el.getAttribute('data-set-theme') == 'white') {
					document.body.setAttribute('data-header-theme', 'white')
				} else if (el.getAttribute('data-set-theme') == 'black') {
					document.body.setAttribute('data-header-theme', 'black')
				}
			},
			onEnterBack: () => {
				if (el.getAttribute('data-set-theme') == 'white') {
					document.body.setAttribute('data-header-theme', 'white')
				} else if (el.getAttribute('data-set-theme') == 'black') {
					document.body.setAttribute('data-header-theme', 'black')
				}
			},
		})
	})

}

export const setThemeOnNavigate = namespace => {

	if (namespace == 'homepage' || namespace == 'insights') {
		document.body.setAttribute('data-header-theme', 'white')
	} else {
		document.body.setAttribute('data-header-theme', 'black')
	}
}

export default () => { }